import React from "react";

// Utility to safely JSON encode
const safeJsonLd = (json) => {
  return JSON.stringify(json).replace(/<\/script>/g, '<\\/script>');
};

const PortfolioStructuredData = ({
  title,
  abstract,
  createdAt,
  publishedAt,
  place,
  country,
  images,
  authorName = "Alberto Lussana",
  authorUrl = "https://lussana.me",
}) => {
  const imageUrls = images?.length
    ? images.map((img) => 
        img.Image?.formats?.large?.url || 
        img.Image?.formats?.medium?.url || 
        img.Image?.url
      ).filter(Boolean)
    : [];

  const schema = {
    "@context": "https://schema.org",
    "@type": "CreativeWork",
    "name": title,
    "description": abstract,
    "author": {
      "@type": "Person",
      "name": authorName,
      "url": authorUrl,
    },
    "dateCreated": createdAt,
    "datePublished": publishedAt,
    "locationCreated": place,
    "countryOfOrigin": country,
    "image": imageUrls.length > 0 ? imageUrls : undefined,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: safeJsonLd(schema) }}
    />
  );
};

export default PortfolioStructuredData;
